import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const CleaningWomanIcon = createIcon({
  displayName: 'CleaningWomanIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M3 21v-.384l-5.91021e-09-.000187859c-2.15961e-07-1.43025 1.00966-2.66161 2.41218-2.94185l2.846-.569 -9.67248e-08 1.93573e-08c.235148-.0470596.47936.00113538.679.134v0l-6.30185e-07-4.20333e-07c1.85465 1.23705 4.27135 1.23705 6.126 9.92609e-07v0l2.07344e-08-1.37992e-08c.19964-.132865.443852-.18106.679-.134l2.846.569 2.72982e-07 5.45805e-08c1.40245.280408 2.41194 1.51183 2.41182 2.94204v.384"></path>
        <path d="M14.639 14h2.361l-6.55671e-08-1.77636e-15c.828427 3.62117e-08 1.5-.671573 1.5-1.5v-4 -6.55671e-08c0-3.58985-2.91015-6.5-6.5-6.5 0 0-6.55671e-08 0-6.55671e-08 0v0l-2.18557e-07 7.10543e-15c-3.58985 1.56917e-07-6.5 2.91015-6.5 6.5v4l8.88178e-16 7.93675e-09c1.25089e-07.828427.671573 1.5 1.5 1.5h2.361"></path>
        <path d="M10 6.619h4l-8.74228e-08 1.77636e-15c1.10457-4.82823e-08 2 .89543 2 2v2.381 0c0 2.20914-1.79086 4-4 4v0l-1.74846e-07-3.55271e-15c-2.20914-9.65645e-08-4-1.79086-4-4 0 0 0-1.77636e-15 0-1.77636e-15v-2.381l2.30926e-14 3.01992e-07c-1.66785e-07-1.10457.89543-2 2-2Z"></path>
        <line x1="7" x2="17" y1="21" y2="21"></line>
        <line x1="16" x2="16" y1="21" y2="17.16"></line>
        <line x1="8" x2="8" y1="21" y2="17.16"></line>
        <line x1="14.1" x2="14.84" y1="14.4" y2="17.38"></line>
        <line x1="9.9" x2="9.16" y1="14.4" y2="17.38"></line>
      </g>
      <rect width="24" height="24" fill="none"></rect>
    </>
  ),
})

const CleaningWoman: FC<IconProps> = (props) => {
  return <CustomIcon as={CleaningWomanIcon} {...props} />
}

export default memo(CleaningWoman)
